// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"1a23f2c4","768":"61368a8c"}[chunkId] + ".chunk.js";
};